import { BooleanInput, Create, SimpleForm, TextInput } from "react-admin";

export function WalletCreate() {
  return (
    <Create redirect="list" mutationMode="pessimistic">
      <SimpleForm>
        <TextInput source="label" label="Метка (необязательно)" helperText="Например: hot-1" fullWidth />
        <TextInput
          source="private_key_hex"
          label="Импорт: приватный ключ (hex, 64 символа)"
          helperText="Оставьте пустым — сгенерируется новый кошелёк"
          fullWidth
          type="password"
        />
        <BooleanInput source="set_primary" label="Сделать primary сразу после создания" defaultValue={false} />
      </SimpleForm>
    </Create>
  );
}
